import React from "react";

const CONDITION_STYLES = {
  "NEW": "bg-emerald-600 text-white",
  "OPEN BOX": "bg-amber-400 text-slate-950",
  "LIKE NEW": "bg-blue-600 text-white",
  "USED": "bg-slate-700 text-white",
  "RETURNED": "bg-purple-600 text-white",
  "REFURBISHED": "bg-indigo-600 text-white",
  "CLEARANCE": "bg-brand-red text-white",
};

const MARKETING_STYLES = {
  "NEW ARRIVAL": "bg-sky-500 text-white",
  "HOT DEAL": "bg-brand-red text-white animate-pulse",
  "LIMITED QUANTITY": "bg-brand-yellow text-slate-950",
  "CLEARANCE": "bg-rose-700 text-white",
  "OPEN BOX": "bg-amber-400 text-slate-950",
  "CUSTOMER RETURN": "bg-violet-600 text-white",
  "SALE": "bg-emerald-600 text-white",
  "FEATURED": "bg-brand-navy text-brand-yellow",
};

export const ConditionBadge = ({ condition, size = "sm" }) => {
  const cls = CONDITION_STYLES[condition] || "bg-slate-700 text-white";
  const sizeCls = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-[11px]";
  return (
    <span data-testid={`condition-badge-${(condition || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`${cls} ${sizeCls} inline-flex items-center font-black uppercase tracking-wider rounded`}>
      {condition}
    </span>
  );
};

export const MarketingBadge = ({ badge }) => {
  const cls = MARKETING_STYLES[badge] || "bg-slate-800 text-white";
  return (
    <span data-testid={`marketing-badge-${badge.toLowerCase().replace(/\s+/g, "-")}`}
      className={`${cls} px-2 py-0.5 rounded-full text-[10px] font-extrabold uppercase tracking-wider`}>
      {badge}
    </span>
  );
};
